// extracted by mini-css-extract-plugin
export default {"grid":"QyQBB","image":"Du1T4"};